/**
 * Created by ivo on 06.05.14.
 */

define([
    'common',
    'jQuery',
    'library/fcse-request/multiRequestHandler',
    'library/fcse-state/Scope',
    'library/fcse-state/urlHandling',
    'clientComponents/countbutton/countButtonExtended',
    'library/fcse-visibilitycontrol/visibilityControl',
    'clientComponents/offervaliditycheck/offerValidityCheckButton',
    'clientComponents/ajaxcontentloader/ajaxContentLoader',
    'clientComponents/lazyimage/lazyImage',
    './widgetFactory'
],
    function (common, $, MultiRequestHandler, Scope, UrlHandling, CountButton, VisibilityControl, OfferValidityCheckButton, AjaxContentLoader, LazyImage, WidgetFactory) {
        // Create scopes
        var rootScope = new Scope(),
            localScope = new Scope(rootScope);

        // Enable URL History
        UrlHandling.enableBrowserHistory(rootScope);

        // Initialize MultiRequestHandler
        var requestHandler = new MultiRequestHandler();

        // Initialize Button
        var countButton = new CountButton(requestHandler, rootScope, '#count-button', {
            updateRoute: 'allt_frontend.package.update_count'
        });
        var ajaxLoader = new AjaxContentLoader('[data-fcse-role="modal-trigger"]', rootScope, {
            'onshow': function(lightboxNode) {
                LazyImage.loadImages(lightboxNode);
                var visibilityControl = new VisibilityControl($('[data-fcse-role="visibility-control"]', lightboxNode),{
                    'targetIsVisibleClass': 'is-active',
                    'targetIsHiddenClass': 'is-collapsed'
                });
            }
        });

        // Handler function for count update
        var favoriteCountUpdate = function(count){
            if (count === 0){
                // Change status of favorites list
                $('[ data-fcse-role="favorites-container"]').addClass('is-empty');
            } else {
                $('[ data-fcse-role="favorites-container"]').removeClass('is-empty');
            }
        };

        $('.offerhorizontal--pricebtn').each(function() {
            new OfferValidityCheckButton($(this), requestHandler, {'offer-selector': '[data-fcse-role="favorites-item"]'});
        });

        var widgetFactory = new WidgetFactory({rootScope : rootScope, localScope : localScope});
    }
);



// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/pages/favorites/index.js